import React from "react";
import "./DrawerTutorial.modules.scss";
import content from "./tutorial-content.json";
import { Colors, GetFeedbackFnType, Tutorial } from "@factorearth/component-library";
import { Location } from "hooks/useDrawer";
import { getFeedback } from "@sentry/react";
import * as FiIcons from "react-icons/fi";
import { feedback } from "index";

interface UserFlow {
	title: string;
	icon?: keyof typeof FiIcons;
	content: string[];
	imgs?: ImageSet;
}

interface ImageSet {
	light: string;
	dark: string;
}
interface Page {
	title: string;
	"page-summary": string;
	"user-flows": UserFlow[];
	features: UserFlow[];
}

interface Props {
	color: Colors;
	location: Location;
	setupDrawer: (location: Location | "") => void;
}

function DrawerTutorial(props: Props) {
	const { color, location, setupDrawer } = props;

	const pages: Record<Location, Page> = content as Record<Location, Page>;
	const page: Page = pages[location];
	return (
		<Tutorial
			colors={color}
			setOpen={setupDrawer}
			page={page}
			reportABugClick={async () => {
				const form = await feedback.createForm();
				form.appendToDom();
				form.open();
			}}
		/>
	);
}

export default DrawerTutorial;
